<template>
    <div class="highSearchWrap">
        <div class="header_sousuo">
            <div style="width:100%;display:flex;margin-bottom: 10px;">
                <div style="width:30%; ">
                    <div style=" display: flex; align-items: end; margin-bottom: 8px;" @click="gohome()">
                        <img style="width:58px;display:block; margin-right: 15px;"  src="../assets/images/shuxiang.png" alt="">
                    <div style="font-size: 40px; ">云田购</div>
                    </div>
                  </div>
                <div style="width:70%;margin-top:1%">
                    <div class="searchcontainer">
                        <input class="searchcontainer-input" v-model="sousuoName" type="text"
                            placeholder="请输入书名,书号,作者或出版社">
                        <div style="width: 100px;height:41px;text-align:center;line-height:41px;background-color:#CA1A1B;color:#fff;font-size:14px;cursor: pointer;"
                            @click="onSubmits()">
                            查询</div>
                    </div>
                    <!-- <div class="suppldetaibox-top">
                        <div style="width:94px ;  ">
                            <el-select v-model="form.status" class="mySelect" popper-class="wentipingSelectPopper" 
                                @change="handleSelectChange" style="width: 94px; margin-right: 20px; ">
                                <el-option v-for="item in statusList" :key="item.value" :value="item.value" 
                                    :label="item.label"></el-option>
                            </el-select>
                        </div>
                        <div style="flex: 1;">
                            <div v-if="form.status == 0" style="display:flex ; align-items: center;position:relative ;">
                                <el-input style="position:relative ;" v-model="tempform.isbns" placeholder="可输入多个ISBN"
                                    readonly @click.native="multiplePop('ISBN','isbns')">
                                </el-input>
                                <i v-if="tempform.isbns" class="el-icon-circle-close circleclose"
                                    style="position: absolute ; right: 25px;" @click="clearValue('isbns')"></i>
                            </div>
                            <div v-if="form.status == 1" style="display:flex ; align-items: center;">
                                <el-input v-model="tempform.bookname" placeholder="请输入书名" clearable @input="handleClear">
                                </el-input>
                            </div>
                            <div v-if="form.status == 2" style="display:flex ; align-items: center;">
                                <el-input placeholder="请输入作者" v-model="tempform.author" clearable @input="handleClear1">
                                </el-input>
                            </div>
                        </div>
                        <div style="width: 100px;height:41px;text-align:center;line-height:41px;background-color:#CA1A1B;color:#fff;font-size:14px;cursor: pointer;"
                            @click="onSubmit()">
                            查询</div>
                    </div> -->
                </div>
            </div>
        </div>
        <div style=" margin:10px 0;height:32px;display: flex;align-items: center;">
            <div v-if="selectedOptionsall.length > 0" style="width: 72px; height:32px;line-height:32px;font-size: 14px; color: #666;" >检索条件：</div>
            <div class="tag-container">
                <el-tag v-for="(item,index) in selectedOptionsall" :key="index" closable @close="handleClose(item)"> {{item}}</el-tag>
                <span v-if="selectedOptionsall.length > 0" style="width:100px; color: #bd2a33;font-size: 14px; cursor: pointer; display: flex; justify-content: center; align-items: center;" @click="clearall()"  >
                    <i class="el-icon-delete"></i>清除所有
                </span>
            </div>
            
        </div>
        <div class="" style="background-color: #fff;border-bottom: 1px solid #eee;margin-bottom:10px;">
            <div class="" style="display:flex; align-items: center; width: 100%;border-top: 1px solid #eee; min-height: 40px; background-color: #f4f4f5;">
                <div style=" width: 100px; height: 100%; margin: 0 auto;">
                    <div style="padding-left: 10px;font-size: 14px; ">出版社：</div>
                </div>
                <div style="flex: 1; display: flex; align-items: center; height: 40px; background-color: #fff; font-size: 14px; overflow: hidden; padding:0 10px;">
                    <div v-for="option in optionscbs" :key="option" @click="toggleSelectioncbs(option)" class="leckname" :class="{ 'selected': selectedOptionsall.includes(option) }" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ option }}</div>
                </div>
                <div style="background-color: rgb(255, 255, 255); width: 50px; height: 40px;display: flex;align-items: center;padding-left: 7px;padding-right: 10px;">
                    <div class="moreTo" @click="pubpop()">更多></div>
                </div>
            </div>
            <div style="display:flex; align-items: center; width: 100%;border-top: 1px solid #eee; min-height: 40px; background-color: #f4f4f5;">
                <div style=" width: 100px; height: 100%; margin: 0 auto;">
                    <div style="padding-left: 10px;font-size: 14px; ">中图法：</div>
                </div>
                <div style="flex: 1; display: flex; padding:0 10px;  align-items: center; height: 40px;background-color: #fff; font-size: 14px; overflow: hidden;">
                    <div class="leckname" v-for="option in optionszt" :key="option" @click="toggleSelectionzt(option)" :class="{ 'selected': selectedOptionsall.includes(option) }" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ option }}</div>
                </div>
                <div style="background-color: rgb(255, 255, 255);width: 50px;height: 40px;display: flex;align-items: center;padding-left: 7px;padding-right: 10px; ">
                    <div class="moreTo" @click="ztfflWindow()">更多></div>
                </div>
            </div>
            <div style="display:flex; align-items: center; width: 100%;border-top: 1px solid #eee; min-height: 40px; background-color: #f4f4f5;">
                <div style=" width: 100px; height: 100%; margin: 0 auto;">
                    <div style="padding-left: 10px;font-size: 14px; ">大众分类：</div>
                </div>
                <div
                    style="flex: 1; display: flex; padding:0 10px;  align-items: center; height: 40px;background-color: #fff; font-size: 14px; overflow: hidden;">
                    <div class="leckname" v-for="option in optionsdz" :key="option" @click="toggleSelectiondz(option)"
                        :class="{ 'selected': selectedOptionsall.includes(option) }"
                        style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ option }}</div>
                </div>
                <div style="background-color: rgb(255, 255, 255);width: 50px;height: 40px;display: flex;align-items: center;padding-left: 7px;padding-right: 10px; ">
                    <div class="moreTo" @click="pubClass()">更多></div>
                </div>
            </div>
            <div
                style="display:flex; align-items: center; width: 100%;border-top: 1px solid #eee; min-height: 40px; background-color: #f4f4f5; overflow: hidden;">
                <div style=" width: 100px; height: 100%; margin: 0 auto;">
                    <div style="padding-left: 10px;font-size: 14px; ">学科分类：</div>
                </div>
                <div
                    style="flex: 1; display: flex; padding:0 10px; align-items: center; height: 40px;background-color: #fff; font-size: 14px;">
                    <div class="leckname" v-for="option in optionsxk" :key="option" @click="toggleSelectionxk(option)"
                        :class="{ 'selected': selectedOptionsall.includes(option) }"
                        style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ option }}</div>
                </div>
                <div style="background-color: rgb(255, 255, 255);width: 50px;height: 40px;display: flex;align-items: center;padding-left: 7px;padding-right: 10px; ">
                    <div class="moreTo" @click="styClass()">更多></div>
                </div>
            </div>
            <div
                style="display:flex; align-items: center; width: 100%;border-top: 1px solid #eee; min-height: 40px; background-color: #f4f4f5;overflow: hidden;">
                <div style=" width: 100px; height: 100%; margin: 0 auto;">
                    <div style="padding-left: 10px;font-size: 14px; ">适用对象：</div>
                </div>
                <div style="flex: 1; display: flex; padding:0 10px; align-items: center; height: 40px;background-color: #fff; font-size: 14px; flex-wrap: nowrap;">
                    <div v-for="(item, index) in objArr" :key="index" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                        :class="{ 'flex-item-14': true, 'selected': item.selected }" class="leckname"
                        @click="toggleSelected1(index)">{{ item.value }}</div>
                </div>
            </div>
            <div
                style="display:flex; align-items: center; width: 100%;border-top: 1px solid #eee; min-height: 40px; background-color: #f4f4f5;">
                <div style=" width: 100px; height: 100%; margin: 0 auto;">
                    <div style="padding-left: 10px;font-size: 14px; ">装帧：</div>
                </div>
                <div
                    style="flex: 1; display: flex; padding:0 10px;  align-items: center; height: 40px;background-color: #fff; font-size: 14px; ">
                    <div v-for="(item, index) in zzArr" :key="index" class="leckname" @click="toggleSelected2(index)"
                        :class="{ 'flex-item-14': true, 'selected': item.selected }">
                        {{ item.value }}
                    </div>
                </div>
            </div>
            <div style="display:flex; align-items: center; width: 100%;border-top: 1px solid #eee; min-height: 40px; background-color: #f4f4f5;">
                <div style=" width: 100px; height: 100%; margin: 0 auto;">
                    <div style="padding-left: 10px;font-size: 14px; ">阅读类型：</div>
                </div>
                <div
                    style="flex: 1; display: flex; padding:0 10px; align-items: center; height: 40px;background-color: #fff; font-size: 14px;">
                    <div v-for="(item, index) in readbooktype" :key="index" class="leckname"
                        @click="toggleSelected3(index)" :class="{ 'flex-item-14': true, 'selected': item.selected }">
                        {{ item.key }}
                    </div>
                </div>
            </div>

            <!-- 支付方式 -->
            <!-- <div style="display:flex; align-items: center; width: 100%;border-top: 1px solid #eee; border-bottom: 1px solid #eee; min-height: 40px; background-color: #f4f4f5;">
                <div style=" width: 100px; height: 100%; margin: 0 auto;">
                    <div style="padding-left: 10px;font-size: 14px; ">支付方式：</div>
                </div>
                <div
                    style="flex: 1; display: flex; padding:0 10px;  align-items: center; height: 40px;background-color: #fff; font-size: 14px; ">
                    <div v-for="(item, index) in Paymentmethod" :key="index" class="leckname"
                        @click="toggleSelected4(index)" :class="{ 'flex-item-14': true, 'selected': item.selected }">
                        {{ item.key }}
                    </div>
                </div>
            </div> -->
            
            <!-- <div
                style="display:flex; align-items: center; width: 100%;border-top: 1px solid #eee; min-height: 40px; background-color: #f4f4f5;">
                <div style=" width: 100px; height: 100%; margin: 0 auto;">
                    <div style="padding-left: 10px;font-size: 16px; ">ISBN</div>
                </div>
                <div
                    style="flex: 1; display: flex;  align-items: center; height: 40px;background-color: #fff; font-size: 14px; padding:0 25px;">
                    <div  style="display:flex ; align-items: center;position:relative ;">
                        <el-input style="position:relative ;" v-model="tempform.isbns" placeholder="可输入多个ISBN"
                            readonly @click.native="multiplePop('ISBN','isbns')">
                        </el-input>
                        <i v-if="tempform.isbns" class="el-icon-circle-close circleclose"
                            style="position: absolute ; right: 25px;" @click="clearValue('isbns')"></i>
                    </div>
                </div>
            </div> -->
            <!-- <el-form label-position="right" label-width="90px" :model="tempform" style="width:100%; margin-top: 10px; display: flex; align-items: center;">
                <el-row :span="24">
                    <el-col :span="5">
                        <el-form-item label="ISBN：" style="font-weight: 700; margin-bottom: 0px;">
                            <div style="display:flex; align-items: center;position:relative;">
                                <el-input size="mini" style="position:relative ;" v-model="tempform.isbns" placeholder="可输入多个ISBN" readonly @click.native="multiplePop('ISBN','isbns')"></el-input>
                                <i v-if="tempform.isbns" class="el-icon-circle-close circleclose" style="position: absolute ; right: 25px;" @click="clearValue('isbns')"></i>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="出版时间：" style="font-weight: 700; margin-bottom: 0px;">
                            <div style="display: flex; align-items: center;">
                                <DatePicker type="month" size="mini" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 100%;" :picker-options="startTime" v-model="tempform.pubfrom"></DatePicker>
                                <el-col class="line" :span="4" style="text-align: center;">-</el-col>
                                <DatePicker type="month" size="mini" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 100%;" :picker-options="endTime" v-model="tempform.pubto"></DatePicker>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="码洋：" style="font-weight: 700; margin-bottom: 0px;">
                            <div style="display: flex; align-items: center;">
                                <el-input size="mini" v-model="tempform.myfrom" clearable style="width: 85px;"></el-input>
                                <el-col class="line" :span="2" style="text-align: center;">-</el-col>
                                <el-input size="mini" v-model="tempform.myto" clearable style="width: 85px;"></el-input>
                                <i class="font" style="font-weight:400 ;font-style: normal; margin-left: 5px;">元</i>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="尺寸：" style="font-weight: 700; margin-bottom: 0px;">
                            <div style="display: flex; align-items: center;">
                                <el-input size="mini" v-model="tempform.min" clearable style="width: 85px;"></el-input>
                                <el-col class="line" :span="2" style="text-align: center;">-</el-col>
                                <el-input size="mini" v-model="tempform.max" clearable style="width: 85px; "></el-input>
                                <i class="font" style="font-weight:400 ;font-style: normal; margin-left: 5px;">cm</i>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="search-btn">
                    <Button type="primary" size="mini" @click="onSubmit" class="submit-btn">确定</Button>
                </div>
            </el-form> -->

            <!-- :style="{height: H}"  -->
            <!-- <div class="search-wrap" :class="{'dropdown':!dropdown}" id="search_top_con">
                <div style=" margin: 0 auto;">
                    <div class="search-box1">
                        <el-form label-position="right" label-width="90px" :model="tempform" style="width:95%;">
                            <el-row :span="24">
                                <el-col :span="9">
                                    <el-form-item label="出版时间：" style="font-weight: 700;">
                                        <div style="display: flex; align-items: center;">
                                            <DatePicker type="month" placeholder="选择日期" value-format="yyyy-MM-dd"
                                                style="width: 100%;" :picker-options="startTime" v-model="tempform.pubfrom">
                                            </DatePicker>
                                            <el-col class="line" :span="4" style="text-align: center;">-</el-col>
                                            <DatePicker type="month" placeholder="选择日期" value-format="yyyy-MM-dd"
                                                style="width: 100%;" :picker-options="endTime" v-model="tempform.pubto">
                                            </DatePicker>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-form-item label="码洋：" style="font-weight: 700;">
                                        <div style="display: flex; align-items: center;">
                                            <el-input v-model="tempform.myfrom" clearable style="width: 85px;"></el-input>
                                            <i class="font" style="font-weight:400 ;font-style: normal;margin-left: 5px;">元</i>
                                            <el-col class="line" :span="4" style="text-align: center;">-</el-col>
                                            <el-input v-model="tempform.myto" clearable style="width: 85px;"></el-input>
                                            <i class="font" style="font-weight:400 ;font-style: normal; margin-left: 5px;">元</i>
    
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-form-item label="尺寸：" style="font-weight: 700;">
                                        <div style="display: flex; align-items: center;">
                                            <el-input v-model="tempform.min" clearable style="width: 85px;"></el-input>
                                            <i class="font" style="font-weight:400 ;font-style: normal; margin-left: 5px;">cm</i>
                                            <el-col class="line" :span="4" style="text-align: center;">-</el-col>
                                            <el-input v-model="tempform.max" clearable style="width: 85px; "></el-input>
                                            <i class="font" style="font-weight:400 ;font-style: normal; margin-left: 5px;">cm</i>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <div v-show="showAdditionalSearch" id='toggle-btn'>
                            </div>
                            <div class="search-btn">
                                <Button type="primary" size="mini" @click="onSubmit" class="submit-btn">检索</Button>
                                <Button @click.native="resetForm" size="mini"
                                    class="iconfont icon-reset reset-btn">重置</Button>
                            </div>
                        </el-form>
                    </div>
                </div>
                <span class="drop_btn" @click="toggleSlide(500)" id= 'toggle-btn' 
                    :class="{'el-icon-top':showAdditionalSearch,'el-icon-bottom':!showAdditionalSearch}">{{showAdditionalSearch?
                    '收起':'展开更多'}}检索条件</span>
            </div> -->
        </div>
        <div class="tab clearfixed">
            <el-table ref="djSort" class="fl" :data="tableData" style="width: 180px" @sort-change="filterChange">
                <el-table-column prop="dj" label="定价" sortable width="80"></el-table-column>
            <!-- </el-table>
            <el-table ref="cbnySort" class="fl" :data="tableData" style="width: 100px" @sort-change="filterChange"> -->
                <el-table-column prop="cbny" label="出版时间" sortable width="100"></el-table-column>
            </el-table>
            <el-form label-position="right" label-width="0px" :model="tempform" style="float:left;margin-top: 13px; display: flex; align-items: center;">
                <el-form-item label="" class="itemline" style="font-weight: 700; margin-bottom: 0px;width:120px;">
                    <div style="display:flex; align-items: center;position:relative;">
                        <el-input size="mini" style="position:relative ;" v-model="tempform.isbns" placeholder="可输入多个ISBN" readonly @click.native="multiplePop('ISBN','isbns')"></el-input>
                        <i v-if="tempform.isbns" class="el-icon-circle-close circleclose" style="position: absolute;color:#ececec; right:5px;" @click="clearValue('isbns')"></i>
                    </div>
                </el-form-item>
                <el-form-item label="" class="itemline" style="font-weight: 700; margin-bottom: 0px;">
                    <div style="display: flex; align-items: center;">
                        <DatePicker type="month" size="mini" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 120px;" :picker-options="startTime" v-model="tempform.pubfrom"></DatePicker>
                        <span class="line">~</span>
                        <DatePicker type="month" size="mini" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 120px;" :picker-options="endTime" v-model="tempform.pubto"></DatePicker>
                    </div>
                </el-form-item>
                <el-form-item label="" class="itemline" style="font-weight: 700; margin-bottom: 0px;">
                    <div style="display: flex; align-items: center;">
                        <el-input size="mini" v-model="tempform.myfrom" clearable style="width: 65px;"></el-input>
                        <span class="line">~</span>
                        <el-input size="mini" v-model="tempform.myto" clearable style="width: 65px;"></el-input>
                        <i class="font" style="font-weight:400 ;font-style: normal; margin-left: 5px;">元</i>
                    </div>
                </el-form-item>
                <el-form-item label="" style="font-weight: 700; margin-bottom: 0px; margin-right: 10px;">
                    <div style="display: flex; align-items: center;">
                        <el-input size="mini" v-model="tempform.min" clearable style="width: 65px;"></el-input>
                        <span class="line">~</span>
                        <el-input size="mini" v-model="tempform.max" clearable style="width: 65px; "></el-input>
                        <i class="font" style="font-weight:400 ;font-style: normal; margin-left: 5px;">cm</i>
                    </div>
                </el-form-item>
                <div class="search-btn">
                    <Button type="primary" plain size="mini" @click="onSubmit" class="submit-btn">确定</Button>
                </div>
            </el-form>
            <div class="showData" style="position: absolute;top:21px;right:100px;font-size: 14px; color: #666;">收录图书<b style="color:#ff1616;padding:0 3px;">5916278</b>种</div>
            <div class="changeMode">
                <span class="listfont" :class="{'filecurrent':filechange}" @click="fileChangeHandle(1)"><i class="boxIcon"></i></span>
                <span class="listfont" :class="{'filecurrent':!filechange}" @click="fileChangeHandle(2)"><i class="listIcon"></i></span>
            </div>
        </div>
    </div>
</template>

<script>
    import { Row, Col, Form, FormItem, Input, Button, Notification, Checkbox, DatePicker, CheckboxGroup, Select, Option } from 'element-ui'
    import classifyPop from './ClassifyPop'
    import studyclass from './studyClassPop'
    import publicpop from './publicPop'
    import Axios from "@/api/diyaxios";
    import popup from '../common/plugin/dialog/index.js'
    import pubDialog from './pubDialog'
    import keyValuePop from './textareaDialog'
    import Cookies from 'js-cookie'
    import { insertPoint } from '@/api/insertPoints'   //添加埋点

    export default {
        props: ['filechange', 'isShowType', 'issmashinggoldeneggs', 'showchubanshe', 'paramss'],
        data() {
            let vm = this;/*  */
            return {
                sousuoName: '',
                showAdditionalSearch: true,
                dianclose: true,
                countdownTime: 6, // 5 minutes in seconds
                timer: null,
                startTime: null,
                pubShow: true,
                zttagShow: true,
                ztfShow: true,
                xkShow: true,
                dzShow: true,
                dropdown: true,//是否展开
                H: this.showAdditionalSearch ? `590px` : `300px`,
                optionscbs: [
                    '北京大学出版社',
                    '清华大学出版社',
                    '武汉大学出版社',
                    '北方文艺出版社',
                    '机械工业出版社',
                    '北京航空航天大学出版社',
                    '北京理工大学出版社',
                    '社会科学文献出版社',
                    '人民邮电出版社',
                ],
                optionszt: [
                    'A马克思主义、列宁主义、毛泽东思想、邓小平理论',
                    'B哲学、宗教',
                    'C社会科学总论',
                    'D政治、法律',
                    'E军事',
                    'F经济',
                    'G文化、科学、教育、体育',
                    'H语言、文字',
                    'I文学',
                    'J艺术',
                   
                ],
                optionsdz: [
                    '01文学小说',
                    '02历史传记',
                    '03经济管理',
                    '04成功励志',
                    '05人文社科',
                    '06IT互联网',
                    '07基础科学',
                    '08工业技术',
                    '09农业科学',
                    '10医学卫生',
                    '11生活',
                    '12艺术',
                    '13少儿',
                    '14外语',
                ],
                optionsxk: [
                    '01哲学',
                    '02经济学',
                    '03法学',
                    '04教育学',
                    '05文学',
                    '06历史学',
                    '07理学',
                    '08工学',
                    '09农学',
                    '10医学',
                    '11军事学',                   

                ],
                selectedOptionsall: [],
                selectedOptionscbs: [],
                selectedOptionszt: [],
                selectedOptionsdz: [],
                selectedOptionsxk: [],
                selectedOptionsbooklist: [],
                selectedOptionskeyWord: [],
                selectedOptionssousuoName: [],
                // 适用对象
                objArr: [
                    { key: '', value: '全部', selected: false },
                    { key: '本科及以上', value: '本科及以上', selected: false },
                    { key: '高职', value: '高职', selected: false },
                    { key: '少儿', value: '少儿', selected: false },
                    { key: '音像电子', value: '音像电子', selected: false },
                    { key: '中职', value: '中职', selected: false },
                    { key: '职业教育', value: '职业教育', selected: false },
                    { key: '成人教育', value: '成人教育', selected: false },
                    { key: '幼儿', value: '幼儿', selected: false },
                    { key: '小学', value: '小学', selected: false },
                    { key: '初中', value: '初中', selected: false },
                    { key: '中小学', value: '中小学', selected: false },
                    { key: '高中', value: '高中', selected: false },
                    { key: '青少年', value: '青少年', selected: false },
                    { key: '通俗读物', value: '通俗读物', selected: false },
                    { key: '继续教育', value: '继续教育', selected: false }
                ],
                zzArr: [//装帧
                    { key: '', value: '平装', selected: false },
                    { key: '精装', value: '精装', selected: false },
                    { key: '线装', value: '线装', selected: false },
                    { key: '活页', value: '活页', selected: false },
                    { key: '其它', value: '其它', selected: false },
                    { key: '函装', value: '函装', selected: false },
                    { key: '盒装', value: '盒装', selected: false }
                ],
                readbooktype: [//阅读类型
                    { key: '纸质书', value: '1', selected: false },
                    { key: '纸电同步', value: '5', selected: false },
                    { key: '电子书', value: '2', selected: false },
                    { key: '期刊', value: '4', selected: false },
                ],
                Paymentmethod: [//支付方式
                    { key: '全部', value: '', selected: false },
                    { key: '期货', value: '0', selected: false },
                    { key: '现货', value: '1', selected: false },
                ],
                statusList: [
                    {
                        value: '0',
                        label: 'ISBN'
                    },
                    {
                        value: '1',
                        label: '书名'
                    },
                    {
                        value: '2',
                        label: '作者'
                    },
                ],
                form: {
                    status: '0'
                },
                tempform: {//表单信息
                    // goodstype:1,
                    isbns: null,
                    bookname: null,
                    author: null,
                    pubname: null,
                    pubid: null,
                    pubfrom: null,
                    pubto: null,
                    ztf: null,
                    subjectShow: null,
                    xkfl: null,
                    dazhongshow: null,
                    dzfl: null,
                    myfrom: null,
                    myto: null,
                    useobj: null,
                    zhuangj: null,
                    activitytag: null,
                    isaddcar: '0',
                    delivery: null,
                    goodsType: null,
                    size: 80,
                    current: 1
                },
                m_modal: null,
                classifydata: null,
                temp_pop: null,
                pub_pop: null,
                key_pop: null,
                savetemp_pop: null,
                sty_clsss: null,
                public_clsss: null,
                xuekedata: null,
                dazhongdata: null,
                pubObjCheck: null,//出版社选中数据
                startTime: {
                    disabledDate: time => {
                        if (vm.tempform.pubto) {
                            return (
                                time.getTime() > new Date(vm.tempform.pubto).getTime()
                            );
                        }
                    }
                },
                endTime: {
                    disabledDate: time => {
                        if (vm.tempform.pubfrom) {
                            return (
                                time.getTime() < new Date(vm.tempform.pubfrom).getTime()
                            );
                        }
                    }
                },
                bindArr: [],
                c: [],
                listname: [],
                quit: require('../assets/zjd_img/quit.png'),
                mubu: require('../assets/zjd_img/mubu.png'),
                msg: '恭喜您中奖了',
                barrageIsShow: true,
                messageHeight: 3,
                boxHeight: 150,
                barrageLoop: true,
                maxWordCount: 3,
                throttleGap: 5000,
                barrageList: [],
                isBeat: false, //砸金蛋弹窗
                isjieguo: false, //砸金蛋结果弹窗
                qiandao: false, //签到弹窗
                Login: false, //登录弹窗
                isAble: false, //禁用按钮
                activateInfo: "", //活动信息
                sign_id: "",
                currentDay: 1, // 当前天
                currentMonth: 1, // 当前月
                currentYear: 1970,
                currentWeek: 1, // 一号所在的星期
                days: [], // 当月所有天数
                content: {},
                arrDate: [], // 当月签到日期
                timeDay: "",
                errorMsg: "",
                success: "",
                num: 0,
                day: 0,
                sign: false,
                input: "书名",
                istimer: null,
                isDoing: 0,
                curStartTime: "",
                day: 0,
                hour: "00",
                min: "00",
                speed: 50,
                myScroll: null,
                startTime: '2022-09-19 00:00:00',  //活动开始时间
                isWinning: false,//手机奖品弹框是否显示
                showToast: false, //显示中奖弹窗
                showstatus: false,  //砸金蛋状态
                //砸金蛋结果
                winResult: null,
                how: false,
                imaguls: '',
                levels: '',
                showsta: false,
                recodePop: false,
                present_name: '',
                rp: null,                
                tableData: [],
                fileChange:true,
            }
        },
        components: {
            Row, Col, Form, FormItem, Input, Button, Notification, Checkbox, DatePicker, CheckboxGroup, Select, Option,
        },
        created() {
            this.fileChange = this.filechange;
            this.rp = JSON.parse(this.$route.query.obj);
            if (this.rp.sousuoName) {
                this.form.status = this.statusList[1].value;
                this.toggleSelectionkeyWord(this.rp.sousuoName)
            } else {
                this.form.status = this.statusList[0].value;
            }
            if(this.rp.pubname){
                this.toggleSelectioncbs(this.rp.pubname)
            }
            // 书单
            if (this.rp.TitleName) {
                this.toggleSelectionbooklist(this.rp.TitleName)
            }
            if (this.rp.zttitle) {
                this.toggleSelectionzt(this.rp.cnIbraryType + this.rp.zttitle)
            }
            if (this.rp.xuekeTitle) {
                this.toggleSelectionxk(this.rp.subjectId + this.rp.xuekeTitle)

            }
            if (this.rp.title) {
                this.toggleSelectiondz(this.rp.publicType + this.rp.title)

            }
            this.startTime = new Date();
            // this.startTimer();
            // this.getWinningRecord()  // 查询个人中没中奖
            // this.getJindan()   // 查询所有中奖记录


            this.objArr.forEach((item, index) => {
                if (index === 0) {
                    item.selected = true;
                    this.tempform.useobj = item.key
                } else {
                    item.selected = false;
                }
            });
            this.zzArr.forEach((item, index) => {
                if (index === 0) {
                    item.selected = true;
                    this.tempform.zhuangj = item.key
                } else {
                    item.selected = false;
                }
            });
            this.Paymentmethod.forEach((item, index) => {
                if (index === 0) {
                    item.selected = true;
                    this.tempform.delivery = item.value


                } else {
                    item.selected = false;
                }
            });
            this.readbooktype.forEach((item, index) => {
                if (index === 0) {
                    item.selected = true;
                    this.tempform.goodsType = item.value

                } else {
                }
            });
        },
        mounted() {
            let vm = this
            // this.myScroll = setInterval(this.scrollUp, this.speed);
            if (vm.$route.name === "calendar") {
                vm.isAble = true;
            }
            vm.bindArr = vm.zzArr;
            vm.$nextTick(() => {
                let isType = vm.isShowType;
                for (var key in isType) {
                    vm[key] = isType[key];
                }
                if (vm.paramss.ztf) {
                    vm.classifydata = vm.paramss.ztf + '|' + vm.paramss.ztf + vm.paramss.ztfName;
                    vm.tempform.ztf = vm.classifydata.split('|')[1];  // 中图分类
                    vm.tempform.ztf = vm.paramss.ztf;
                }
                if (vm.paramss.xkfl) {
                    vm.xuekedata = vm.paramss.xkfl + '|' + vm.paramss.xkfl + vm.paramss.zxkName; // 学科分类
                    vm.tempform.subjectShow = vm.xuekedata.split('|')[1];// 学科类别
                    vm.tempform.xkfl = vm.paramss.xkfl;
                }
                if (vm.paramss.dzfl) {
                    vm.dazhongdata = vm.paramss.dzfl + '|' + vm.paramss.dzfl + vm.paramss.dzflName; // 大众分类
                    vm.tempform.dazhongshow = vm.dazhongdata.split('|')[1];
                    vm.tempform.dzfl = vm.paramss.dzfl;
                }
            })
        },
        methods: {
            fileChangeHandle(val){
                let vm = this;
                vm.tempform.current = 1;
                if(val == 1){
                    vm.fileChange = true;
                    vm.tempform.size = 80;
                    // vm.DiFangData(vm.params);
                }else if(val == 2){
                    vm.fileChange = false;
                    vm.tempform.size = 20;
                    // vm.$nextTick(() => {
                    //     vm.$refs.listBook.submitForm(vm.params);
                    // });
                }
                // vm.onSubmit();
                vm.$emit('fileChange', val);
            },
            
            // 筛选排序
            filterChange(filters) {
                let rule = {},
                    sort;
                // this.$refs.djSort.clearSort();
                // this.$refs.cbnySort.clearSort();
                if (filters.order === "descending") {
                    sort = "desc";
                } else if(filters.order === "ascending") {
                    sort = "asc";
                }else{
                    sort = '';
                }
                if(sort != ''){
                    rule[filters.prop] = sort;
                    this.tempform.sortRules = JSON.stringify(rule);
                }else{
                    rule={};
                    delete this.tempform.sortRules;
                }
                this.onSubmit();
                // Cookies.set('PublishingPagesTypeIdOrderBy', this.params.sortRules)
                // this.DiFangData(this.params);
            },
            gohome(){
                this.$router.push({ name: 'Xindex' });
            },
            toggleSelectionkeyWord(option) {
                const index = this.selectedOptionsall.indexOf(option);
                if (index !== -1) {
                    this.selectedOptionsall.splice(index, 1);
                    this.selectedOptionskeyWord = this.selectedOptionskeyWord.filter(item => item != option);
                    if (option == this.sousuoName) {
                        this.sousuoName = ''
                    }
                    this.tempform.keyWord = ''
                    this.onSubmit()  // 检索  
                } else {
                    if (this.selectedOptionskeyWord.length > 0) {
                        this.selectedOptionsall = this.selectedOptionsall.filter(item => !this.selectedOptionskeyWord.includes(item));
                        this.selectedOptionskeyWord = this.selectedOptionskeyWord.filter(item => !this.selectedOptionsall.includes(item));
                    }
                    this.selectedOptionsall.push(option);
                    this.selectedOptionskeyWord.push(option);
                    this.tempform.keyWord = option;
                    this.onSubmit()  // 检索
                }
            },
            toggleSelectionbooklist(option) {
                const index = this.selectedOptionsall.indexOf(option);
                if (index !== -1) {
                    this.selectedOptionsall.splice(index, 1);
                    this.selectedOptionsbooklist = this.selectedOptionsbooklist.filter(item => item != option);
                    this.tempform.activitytag = ''
                    this.onSubmit()  // 检索  
                } else {
                    this.selectedOptionsall.push(option);
                    this.selectedOptionsbooklist.push(option);
                    this.tempform.activitytag = this.rp.activitytag;
                    this.onSubmit()  // 检索
                }
            },
            toggleSelectioncbs(option) {
                const index = this.selectedOptionsall.indexOf(option);
                if (index !== -1) {
                    this.selectedOptionsall.splice(index, 1);
                    this.selectedOptionscbs = this.selectedOptionscbs.filter(item => item != option);
                    this.tempform.pubname = this.selectedOptionscbs.join(',');
                    this.onSubmit()  // 检索  
                } else {
                    this.selectedOptionsall.push(option);
                    this.selectedOptionscbs.push(option);
                    this.tempform.pubname = this.selectedOptionscbs.join(',');
                    this.onSubmit()  // 检索
                }
            },
            toggleSelectionzt(option) {
                const index = this.selectedOptionsall.indexOf(option);
                if (index !== -1) {
                    this.selectedOptionsall.splice(index, 1);
                    this.selectedOptionszt = this.selectedOptionszt.filter(item => item != option);
                    const firstChars = this.selectedOptionszt.map(str => {
                        const match = str.match(/^[a-zA-Z\u4e00-\u9fa5]/); // 使用正则表达式匹配字母或汉字开头
                        return match ? match[0] : ''; // 如果匹配到字母或汉字开头，则返回第一个字母或汉字，否则返回空字符串
                    });
                    if (this.selectedOptionszt.length == 1) {
                        this.tempform.classifydata = this.selectedOptionszt[0];
                    } else {
                        this.tempform.classifydata = this.selectedOptionszt.join(',');
                    }
                    if (firstChars.length == 1) {
                        this.tempform.ztf = firstChars[0];
                    } else {
                        this.tempform.ztf = firstChars.join(',');
                    }
                    this.onSubmit()
                    this.classifydata = this.tempform.ztf + '|' + this.tempform.classifydata;
                } else {
                    this.selectedOptionsall.push(option);
                    this.selectedOptionszt.push(option);
                    console.log('选中:', this.selectedOptionszt);
                    const firstChars = this.selectedOptionszt.map(str => {
                        const match = str.match(/^[a-zA-Z\u4e00-\u9fa5]/); // 使用正则表达式匹配字母或汉字开头
                        return match ? match[0] : ''; // 如果匹配到字母或汉字开头，则返回第一个字母或汉字，否则返回空字符串
                    });
                    if (this.selectedOptionszt.length == 1) {
                        this.tempform.classifydata = this.selectedOptionszt[0];
                    } else {
                        this.tempform.classifydata = this.selectedOptionszt.join(',');
                    }
                    if (firstChars.length == 1) {
                        this.tempform.ztf = firstChars[0];
                    } else {
                        this.tempform.ztf = firstChars.join(',');
                    }
                    this.onSubmit()  // 检索
                    this.classifydata = this.tempform.ztf + '|' + this.tempform.classifydata;
                }
            },
            toggleSelectiondz(option) {
                const index = this.selectedOptionsall.indexOf(option);
                if (index !== -1) {
                    this.selectedOptionsall.splice(index, 1);
                    this.selectedOptionsdz = this.selectedOptionsdz.filter(item => item != option);
                    console.log('取消选中:', option, this.selectedOptionsall);
                    const numbers = this.selectedOptionsdz.map(str => {
                        const match = str.match(/^\s*(\d+)/); // 使用正则表达式匹配数字开头
                        return match ? match[1] : ''; // 如果匹配到数字开头，则返回匹配到的数字，否则返回空字符串
                    });
                    if (this.selectedOptionsdz.length == 1) {
                        this.tempform.dazhongshow = this.selectedOptionsdz[0];
                    } else {
                        this.tempform.dazhongshow = this.selectedOptionsdz.join(',');
                    }
                    if (numbers.length == 1) {
                        this.tempform.dzfl = numbers[0];
                    } else {
                        this.tempform.dzfl = numbers.join(',');
                    }
                    this.dazhongdata = this.tempform.dzfl + '|' + this.tempform.dazhongshow;
                    this.onSubmit()  // 检索
                } else {
                    this.selectedOptionsall.push(option);
                    this.selectedOptionsdz.push(option);
                    console.log('选中:', this.selectedOptionsdz);
                    const numbers = this.selectedOptionsdz.map(str => {
                        const match = str.match(/^\s*(\d+)/); // 使用正则表达式匹配数字开头
                        return match ? match[1] : ''; // 如果匹配到数字开头，则返回匹配到的数字，否则返回空字符串
                    });
                    if (this.selectedOptionsdz.length == 1) {
                        this.tempform.dazhongshow = this.selectedOptionsdz[0];
                    } else {
                        this.tempform.dazhongshow = this.selectedOptionsdz.join(',');
                    }
                    if (numbers.length == 1) {
                        this.tempform.dzfl = numbers[0];
                    } else {
                        this.tempform.dzfl = numbers.join(',');
                    }
                    this.dazhongdata = this.tempform.dzfl + '|' + this.tempform.dazhongshow;
                    this.onSubmit()  // 检索
                }
            },
            toggleSelectionxk(option) {
                const index = this.selectedOptionsall.indexOf(option);
                if (index !== -1) {
                    this.selectedOptionsall.splice(index, 1);
                    this.selectedOptionsxk = this.selectedOptionsxk.filter(item => item != option);
                    console.log('取消选中:', option, this.selectedOptionsxk);
                    const numbersxk = this.selectedOptionsxk.map(str => {
                        const match = str.match(/^\s*(\d+)/); // 使用正则表达式匹配数字开头
                        return match ? match[1] : ''; // 如果匹配到数字开头，则返回匹配到的数字，否则返回空字符串
                    });
                    if (this.selectedOptionsxk.length == 1) {
                        this.tempform.subjectShow = this.selectedOptionsxk[0];
                    } else {
                        this.tempform.subjectShow = this.selectedOptionsxk.join(',');
                    }
                    if (numbersxk.length == 1) {
                        this.tempform.xkfl = numbersxk[0];
                    } else {
                        this.tempform.xkfl = numbersxk.join(',');
                    }
                    this.xuekedata = this.tempform.xkfl + '|' + this.tempform.subjectShow;
                    this.onSubmit()  // 检索
                } else {
                    this.selectedOptionsall.push(option);
                    this.selectedOptionsxk.push(option);
                    console.log('选中:', this.selectedOptionsxk);
                    const numbersxk = this.selectedOptionsxk.map(str => {
                        const match = str.match(/^\s*(\d+)/); // 使用正则表达式匹配数字开头
                        return match ? match[1] : ''; // 如果匹配到数字开头，则返回匹配到的数字，否则返回空字符串
                    });
                    if (this.selectedOptionsxk.length == 1) {
                        this.tempform.subjectShow = this.selectedOptionsxk[0];
                    } else {
                        this.tempform.subjectShow = this.selectedOptionsxk.join(',');
                    }
                    if (numbersxk.length == 1) {
                        this.tempform.xkfl = numbersxk[0];
                    } else {
                        this.tempform.xkfl = numbersxk.join(',');
                    }
                    this.xuekedata = this.tempform.xkfl + '|' + this.tempform.subjectShow;
                    this.onSubmit()  // 检索
                }
            },
            handleClose(tag) {
                if (this.selectedOptionscbs.includes(tag)) {
                    this.toggleSelectioncbs(tag)
                } else if (this.selectedOptionszt.includes(tag)) {
                    this.toggleSelectionzt(tag)
                } else if (this.selectedOptionsdz.includes(tag)) {
                    this.toggleSelectiondz(tag)
                } else if (this.selectedOptionsxk.includes(tag)) {
                    this.toggleSelectionxk(tag)
                } else if (this.selectedOptionsbooklist.includes(tag)) {
                    this.toggleSelectionbooklist(tag)
                } else if (this.selectedOptionskeyWord.includes(tag)) {
                    this.toggleSelectionkeyWord(tag)
                } else {
                    this.selectedOptionsall.splice(this.selectedOptionsall.indexOf(tag), 1);
                    if (this.selectedOptionsall.length == 0) {
                        this.tempform.bookname = ''
                        this.tempform.keyWord = ''
                        this.tempform.activitytag = ''
                    }
                    this.onSubmit()  // 检索
                }
            },
            scrollUp() {
                const area = document.getElementById('moocBox');
                const con1 = document.getElementById('con1');
                const con2 = document.getElementById('con2');

                if (area.scrollTop >= con1.scrollHeight) {
                    area.scrollTop = 0;
                } else {
                    area.scrollTop++;
                }
            },
            toggleSelected1(index) {
                this.objArr.forEach((item, i) => {
                    if (i === index) {
                        item.selected = true;
                        this.tempform.useobj = item.key
                    } else {
                        item.selected = false;
                    }
                });
                this.onSubmit()
            },
            toggleSelected2(index) {
                this.zzArr.forEach((item, i) => {
                    if (i === index) {
                        item.selected = true;
                        this.tempform.zhuangj = item.key
                    } else {
                        item.selected = false;
                    }
                });
                this.onSubmit()
            },
            toggleSelected3(index) {
                this.readbooktype.forEach((item, i) => {
                    if (i === index) {
                        item.selected = true;
                        this.tempform.goodsType = item.value
                    } else {
                        item.selected = false;
                    }
                });
                this.onSubmit()

            },
            toggleSelected4(index) {
                this.Paymentmethod.forEach((item, i) => {
                    if (i === index) {
                        item.selected = true;
                        this.tempform.delivery = item.value
                    } else {
                        item.selected = false;
                    }
                });
                this.onSubmit()

            },
            // handleSelectChange(value) {
            //     this.form.status = value
            // },
            //弹开收起
            toggleSlide(s) {
                // let vm = this,
                // div = document.getElementById('search_top_con');
                // div.style.transition = 'height ' + s + 'ms';
                // vm.dropdown = !vm.dropdown;
                // if (vm.dropdown) vm.H = vm.showAdditionalSearch?`590px`  : `300px` ; else vm.H = `25px`
                this.toggleAdditionalSearch(s)
            },
            toggleAdditionalSearch(s) {
                let vm = this,
                    div = document.getElementById('search_top_con');
                div.style.transition = 'height ' + s + 'ms';
                this.showAdditionalSearch = !this.showAdditionalSearch;
                if (this.showAdditionalSearch) this.H = `590px`; else this.H = `300px`
            },
            zajindan() {
                this.isBeat = true;
            },
            iSlogin() {
                return Cookies.get('token') ? true : false;
            },
            onSubmits() {
                this.toggleSelectionkeyWord(this.sousuoName)
            },
            //检索
            onSubmit() {
                let vm = this,
                    queryFormData = {};  
                // queryFormData = JSON.parse(JSON.stringify(vm.tempform));
                queryFormData = vm.tempform;
                // console.log(vm.tempform,'vm.tempform');
                let isbns = queryFormData.isbns,
                    activitytag = queryFormData.activitytag;
                if (isbns && isbns != '') queryFormData.isbns = isbns.replace(/-/g, '');
                if (activitytag && activitytag.length > 0) queryFormData.activitytag = activitytag.join(','); else queryFormData.activitytag = '';
                delete queryFormData.subjectShow;
                delete queryFormData.dazhongshow;
                let doId = +localStorage.getItem('doId') + 1;
                localStorage.setItem('doId', doId);
                insertPoint(queryFormData, 'click', 'search', doId); //添加“高级检索”埋点
                console.log('1111');
                vm.$emit('submitForm', queryFormData);
            },
            //清除
            clearValue(prop, val, data) {
                const index = this.selectedOptionsall.indexOf(this.tempform.isbns);
                if (index !== -1) {
                    this.selectedOptionsall.splice(index, 1);
                    this.tempform.isbns = ''
                    this.onSubmit()  // 检索
                }
                let vm = this;
                vm.tempform[prop] = null;
                if (val) vm[val] = null;
                if (data) vm.tempform[data] = null;
            },
           
           
            clearall(){
                this.selectedOptionsall=[];
                this.selectedOptionscbs=[];
                this.selectedOptionszt=[];
                this.selectedOptionsdz=[];
                this.selectedOptionsxk=[];
                this.selectedOptionsbooklist=[];
                this.selectedOptionskeyWord=[];
                this.selectedOptionssousuoName=[]
                this.resetForm()
            },
            //重置
            resetForm() {
                let vm = this;
                vm.classifydata = null;
                vm.xuekedata = null;
                vm.dazhongdata = null;
                vm.tempform.xkfl = null;
                vm.tempform.dzfl = null;
                vm.tempform.pubid = null;
                vm.tempform.isbns = null;
                vm.tempform.bookname = null;
                vm.tempform.myfrom = null;
                vm.tempform.myto = null;
                vm.tempform.author = null;
                vm.tempform.pubname = '';
                vm.tempform.ztf = null;
                vm.tempform.subjectShow = null;
                vm.tempform.dazhongshow = null;
                vm.tempform.classifydata = null;
                vm.tempform.pubfrom = null;
                vm.tempform.pubto = null;
                vm.tempform.min = null;
                vm.tempform.max = null;
                this.objArr.forEach((item, index) => {
                    if (index === 0) {
                        item.selected = true;
                        this.tempform.useobj = item.key
                    } else {
                        item.selected = false;
                    }
                });
                this.zzArr.forEach((item, index) => {
                    if (index === 0) {
                        item.selected = true;
                        this.tempform.zhuangj = item.key
                    } else {
                        item.selected = false;
                    }
                });
                this.Paymentmethod.forEach((item, index) => {
                    if (index === 0) {
                        item.selected = true;
                        this.tempform.delivery = item.value


                    } else {
                        item.selected = false;
                    }
                });
                this.readbooktype.forEach((item, index) => {
                    if (index === 0) {
                        item.selected = true;
                        this.tempform.goodsType = item.value

                    } else {
                    }
                });
                this.onSubmit()
            },
            //中图法
            ztfflWindow() {
                let vm = this;
                vm.m_modal = popup('<classify-pop @close="close" @ok="submit" :msg="msg"/>', {
                    option: {
                        title: '中图法分类',
                        width: '800px'
                    },
                    popup: {
                        data() {
                            return {
                                msg: vm.classifydata
                            }
                        },
                        components: {
                            classifyPop
                        },
                        methods: {
                            submit(data) {
                                vm.classifydata = data.dataStr;
                                let arr = data.dataStr.split('|');
                                vm.tempform.ztf = arr[0];
                                vm.tempform.classifydata = arr[1];
                                if (arr[0] == "") {
                                    // 过滤掉数组1和数组2中相同的元素
                                    let filteredArray1 =  vm.selectedOptionsall.filter(function (item) {
                                        return !vm.selectedOptionszt.includes(item);
                                    });
                                    // 过滤掉数组2中和数组1相同的元素，并清空数组2中相同的元素
                                    let filteredArray2 = vm.selectedOptionszt.filter(function (item) {
                                        return !vm.selectedOptionsall.includes(item);
                                    });
                                    vm.selectedOptionsall  = filteredArray1
                                    // 更新数组2为过滤后的结果，即清空了和数组1相同的元素
                                    vm.selectedOptionszt = filteredArray2;
                                    vm.tempform.classifydata = '';
                                    vm.tempform.ztf = '';
                                    vm.onSubmit()
                                } else {
                                    arr[1].split(',').map(item => item.trim()).forEach(function (items) {
                                        if (!vm.selectedOptionszt.includes(items)) {
                                            vm.toggleSelectionzt(items)
                                        }
                                    });
                                }

                                vm.m_modal.hide();
                            },
                            close(data) {
                                vm.m_modal.hide();
                            }
                        }
                    }
                });
                vm.m_modal.show();
            },
            //学科分类
            styClass() {
                let vm = this;
                vm.sty_clsss = popup('<studyclass @close="close" @ok="submit" :msg="msg"/>', {
                    option: {
                        title: '学科分类',
                        width: '630px'
                    },
                    popup: {
                        data() {
                            return {
                                msg: vm.xuekedata
                            }
                        },
                        components: {
                            studyclass
                        },
                        methods: {
                            submit(data) {
                                vm.xuekedata = data;
                                let arr = data.split('|');
                                vm.tempform.subjectShow = arr[1];
                                vm.tempform.xkfl = arr[0];
                                if (arr[0] == "") {
                                    // 过滤掉数组1和数组2中相同的元素
                                    let filteredArray1 =  vm.selectedOptionsall.filter(function (item) {
                                        return !vm.selectedOptionsxk.includes(item);
                                    });
                                    // 过滤掉数组2中和数组1相同的元素，并清空数组2中相同的元素
                                    let filteredArray2 = vm.selectedOptionsxk.filter(function (item) {
                                        return !vm.selectedOptionsall.includes(item);
                                    });
                                    vm.selectedOptionsall  = filteredArray1
                                    // 更新数组2为过滤后的结果，即清空了和数组1相同的元素
                                    vm.selectedOptionsxk = filteredArray2;
                                    vm.tempform.xkfl = '';
                                    vm.tempform.subjectShow = '';
                                    vm.onSubmit()
                                } else {
                                    arr[1].split(',').map(item => item.trim()).forEach(function (items) {
                                    if (!vm.selectedOptionsxk.includes(items)) {
                                        vm.toggleSelectionxk(items)
                                    }
                                });
                                }
                               
                                vm.sty_clsss.hide();
                            },
                            close(data) {
                                vm.sty_clsss.hide();
                            }
                        }
                    }
                });
                vm.sty_clsss.show();
            },
            //大众分类
            pubClass() {
                let vm = this;
                vm.public_clsss = popup('<publicpop @close="close" @ok="submit" :msg="msg" :search="0" :datatype="3"/>', {
                    option: {
                        title: '大众分类',
                        width: '600px',
                        height: '560px'
                    },
                    popup: {
                        data() {
                            return {
                                msg: vm.dazhongdata
                            }
                        },
                        components: {
                            publicpop
                        },
                        methods: {
                            submit(data) {
                                vm.dazhongdata = data;
                                let arr = data.split('|');
                                vm.tempform.dazhongshow = arr[1];
                                vm.tempform.dzfl = arr[0];
                                if (arr[0] == "") {
                                    // 过滤掉数组1和数组2中相同的元素
                                    let filteredArray1 =  vm.selectedOptionsall.filter(function (item) {
                                        return !vm.selectedOptionsdz.includes(item);
                                    });
                                    // 过滤掉数组2中和数组1相同的元素，并清空数组2中相同的元素
                                    let filteredArray2 = vm.selectedOptionsdz.filter(function (item) {
                                        return !vm.selectedOptionsall.includes(item);
                                    });
                                    vm.selectedOptionsall  = filteredArray1
                                    // 更新数组2为过滤后的结果，即清空了和数组1相同的元素
                                    vm.selectedOptionsdz = filteredArray2;
                                    vm.tempform.dzfl = '';
                                    vm.tempform.dazhongshow = '';
                                    vm.onSubmit()
                                } else {
                                    arr[1].split(',').map(item => item.trim()).forEach(function (items) {
                                    if (!vm.selectedOptionsdz.includes(items)) {
                                        vm.toggleSelectiondz(items)
                                    }
                                });
                                }


                               


                                vm.public_clsss.hide();
                            },
                            close(data) {
                                vm.public_clsss.hide();
                            }
                        }
                    }
                });
                vm.public_clsss.show();
            },
            //出版社
            pubpop() {
                let vm = this;
                vm.pub_pop = popup('<pub-dialog @close="close" :msg="msg" @ok="submit" />', {
                    option: {
                        title: '出版社选择',
                        width: '630px'
                    },
                    popup: {
                        data() {
                            return {
                                msg: vm.selectedOptionscbs
                            }
                        },
                        components: {
                            pubDialog
                        },
                        methods: {
                            submit(data) {
                                // vm.tempform.pubname = data.pubname;
                                vm.tempform.pubid = data.pubid;
                                vm.pubObjCheck = data.choosedData;
                                if(data.choosedData.length>0){
                                    data.choosedData.forEach(function (item) {
                                    var name = item.orgName;
                                    if (!vm.selectedOptionscbs.includes(name)) {
                                        vm.toggleSelectioncbs(name)
                                    }
                                });
                                }else{
                                    let filteredArray1 =  vm.selectedOptionsall.filter(function (item) {
                                        return !vm.selectedOptionscbs.includes(item);
                                    });
                                    // 过滤掉数组2中和数组1相同的元素，并清空数组2中相同的元素
                                    let filteredArray2 = vm.selectedOptionscbs.filter(function (item) {
                                        return !vm.selectedOptionsall.includes(item);
                                    });
                                    vm.selectedOptionsall  = filteredArray1
                                    // 更新数组2为过滤后的结果，即清空了和数组1相同的元素
                                    vm.selectedOptionsdz = filteredArray2;
                                    vm.tempform.pubname = '';
                                    vm.onSubmit()
                                }
                               
                                vm.pub_pop.hide();
                            },
                            close(data) {
                                vm.pub_pop.hide();
                            }
                        }
                    }
                })
                vm.pub_pop.show();
            },
            //关键词
            multiplePop(txt, flag) {
                let vm = this,
                    val = '';
                val = vm.tempform[flag];
                vm.key_pop = popup('<key-value-pop @close="close" @ok="submit" :msg="msg" />', {
                    option: {
                        title: `多个${txt}批量查询`,
                        width: '336px'
                    },
                    popup: {
                        data() {
                            return {
                                msg: {
                                    val: val,
                                    flag: flag
                                }
                            }
                        },
                        components: {
                            keyValuePop
                        },
                        methods: {
                            submit(data) {
                                let flag = data.flag;
                                vm.tempform[flag] = data.val;
                                vm.key_pop.hide();
                            },
                            close() {
                                vm.key_pop.hide();
                            }
                        }
                    }
                })
                vm.key_pop.show();
            },




        }
    };
</script>

<style lang='scss'>
.highSearchWrap{
    .tab{
        background-color: #f4f4f5;
        .el-table th.el-table__cell.is-leaf{
            border-bottom:0 none;
        }
        .el-table th.el-table__cell{
            background: #f4f4f5;
        }
        .el-table::before{
            background-color: initial;
        }
        .el-date-editor{
            &.el-input--suffix .el-input__inner{
                padding-left:25px;
            }
        }
        .el-input--suffix .el-input__inner{
            padding: 0 5px;
        } 
        .itemline{
            padding-right: 10px;
            margin-right: 8px;
            background: url('../assets/images/itemline.png') no-repeat right center;
            // border-right:1px solid #999;
        }
        .line{
            text-align: center;
            font-weight: normal;
            color: #969696;
        }        
        .changeMode{
            // float:right;
            position: absolute;
            right:10px;
            top:13px;
            .listfont{
                display: inline-block;
                margin-left:-1px;
                width: 32px;
                height: 32px;
                border-radius: 2px 0 0 2px;
                border: 1px solid #DCDFE6;
                line-height: 28px;
                text-align: center;
                background-color: #fff;
                cursor: pointer;
                i{
                    display: block;
                    width: 24px;
                    height: 24px;
                    margin:4px;
                    background-repeat: no-repeat;
                    background-size:100%;
                }
                i.boxIcon{
                    background-image: url("../assets/images/boxlist.png");
                }
                i.listIcon{
                    background-image: url("../assets/images/tablist.png");
                }
            }
            .filecurrent{
                i.boxIcon{
                    background-image: url("../assets/images/boxlist_cur.png");
                }
                i.listIcon{
                    background-image: url("../assets/images/tablist_cur.png");
                }
            }
        }
    }   
    .search-box1 {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 0 15px 15px 15px;
        margin: 0 auto;
        /* border-top: 2px solid #333;
        border-bottom: 2px solid #333;
        background-color: yellowgreen; */

    }

    .suppldetaibox-top {
        margin: 25px auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .flex-container {
        display: flex;
        flex-wrap: wrap;
    }

    .flex-item {
        flex: 0 0 calc(8.14% - 10px);
        /* 每个元素占据约 7.14% 的宽度，减去间隔 */
        margin: 5px;
        /* 设置元素间隔 */
        text-align: center;
        /* 文字居中显示 */
        cursor: pointer;
        font-weight: 400;
        line-height: 30px;
        /* 鼠标指针样式为手型 */
    }

    .leckname.selected, .lecknames.selected {
        // background-color: lightblue;
        color:#ca1a1b;
        font-weight: 700;
        /* 设置选中样式，可以根据需要调整 */
    }

    .el-form-item__content {
        line-height: 30px !important;
        font-size: 14px;
    }

    .suppldetaibox {
        margin: 0 auto;
        width: 80%;
        /* height: 3000px; */
        /* background-color: #f13536; */
    }

    .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }

    .titleNames {}

    .mySelect {
        width: 100px;
    }

    .search-wrap {
        background-color: #fff;
        position: relative;
        overflow: hidden;

        .drop_btn {
            position: absolute;
            display: block;
            line-height: 30px;
            padding: 0px 40px;
            cursor: pointer;
            bottom: 0px;
            right: 0px;
            color: #999;
        }

        .no-margin {
            margin: 0 !important;
            // width:72px;
        }

        /* .el-input {
            width: 192px;
        } */

        .el-input__inner {
            /* padding: 0px 8px; */
            height: 35px;
            /* width: 192px; */
        }

        .s-input {
            float: left;
            width: 75px;

            .el-form-item__content {
                .midbox {
                    width: 52px;
                }
            }

            .el-input__inner {
                padding: 0px 8px;
                width: 52px;
            }
        }

        .date-input {
            float: left;
            width: 130px;

            .el-input__inner {
                padding: 0px 8px;
                width: 128px;
            }
        }

        .el-input--prefix .el-input__inner {
            padding-left: 25px;
        }

        .line {
            text-align: center;
        }

        .s-input {
            .el-input {
                width: 70%;
            }

            i {
                font-style: normal;
            }
        }

        .el-form-item__label {
            padding-right: 5px;
            font-size: 12px;
        }

        .search-btn {
            text-align: center;
            padding-top: 15px;
        }

        //表单清除
        .labelwrap {
            position: relative;

            .circleclose {
                display: none
            }

            .el-form-item__content:hover .circleclose {
                position: absolute;
                cursor: pointer;
                top: 3px;
                right: 0px;
                height: 24px;
                line-height: 24px;
                width: 24px;
                text-align: center;
                color: #bcc0c5;
                display: block;
            }
        }
    }

    /* 分类弹框样式 */
    .cont-sty {

        //学科、大众
        .el-col .treebox {
            width: 209px;
            height: 323px;
            padding: 15px 0 0 15px;
            padding-right: 0px;
            margin: 28px 0 0 38px;
            background-color: #fff;
            border-radius: 4px;
            border: solid 1px #c9d7e8;

            .search-sty {
                .el-input__inner {
                    width: 200px;
                    height: 32px;
                    padding-left: 28px;
                    background-color: #fff;
                    border-radius: 16px;
                    height: 28px;
                    line-height: 28px;
                    border: solid 1px #b6d2e6;
                }

                .el-icon-search {
                    line-height: 32px;
                }
            }

            .lefttree {
                height: 291px;
                overflow: auto;
                list-style: none;

                .check-box {
                    cursor: pointer;
                    margin-top: 10px;
                }
            }

            .tit {
                font-weight: bold;
                font-size: 13px;
            }

            .right-tree {
                width: 209px;
                height: 301px;
                overflow: auto;
                list-style: none;
                padding: 0px;

                >li {
                    cursor: pointer;
                    margin-top: 10px;

                    span {
                        display: inline-block;
                        width: 170px;
                        font-size: 12px;
                    }

                    i {
                        font-size: 17px;
                        color: #bbc8d4;
                    }

                    &:hover i {
                        color: #1c7bd3;
                    }
                }

                >li:hover {
                    color: #1c7bd3;
                }
            }

            .noData {
                text-align: center;
                font-size: 12px;

                img {
                    height: 90px;
                    width: 70px;
                    margin: 30px auto 15px;
                    display: block;
                }

                .p {
                    margin: 4px;
                }
            }

        }
    }

    .clearbtn {
        float: right;
        margin-right: 18px;
        width: 47px;
        height: 22px;
        line-height: 22px;
        background-color: #ffeaea;
        border-radius: 2px;
        border: 1px solid #f2c3c3;
        color: #ce4747;
    }

    .btnbase {
        border: 0px;
        // border-radius: 50px;
        font-weight: bold;
        font-size: 12px;
        cursor: pointer;
        // padding:0 24px;
        display: inline-block;
        height: 33px;
        line-height: 33px;
        margin: 8px 12px;
        width: 70px;
        background-color: #deefff;
        border-radius: 4px;
    }

    .btn_box {
        //按钮样式
        text-align: center;
        margin-top: 15px;

        .btn_sure {
            @extend .btnbase;
            color: #fff;
            background-color: #2c88f4;
        }

        .btn_canle {
            @extend .btnbase;
            color: #2c88f4;
            background-color: #deefff;
        }

        .btn_green {
            @extend .btnbase;
            color: #fff;
            background-color: #67c23a;
        }
    }



    .zjd {
        margin: 30px auto;
        height: 700px;
        position: relative;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .zjdBg {
        /* 
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    // background: rgba(235, 228, 228 / 80%);
    z-index: 100;
    overflow-y: hidden; */

        .zjdContent {
            height: 100%;
            color: #fff;

            .supplier {
                height: 40px;
                line-height: 40px;
                text-align: center;
                background-color: cadetblue;
            }

            .nextTime {
                height: 40px;
                line-height: 40px;
                text-align: center;
                background-color: #fb7d0f;
            }

            .activityContent {
                // display: flex;
                height: 100%;

                .Sessions {
                    width: 100%;
                    height: 100%;
                    line-height: 50px;
                    text-align: center;
                    // background-color: aquamarine;
                }
            }
        }
    }

    .zjdClose {
        position: absolute;
        width: 30px;
        height: 30px;
        top: 20px;
        right: 20px;
        cursor: pointer;
        z-index: 109;

        img {
            width: 30px;
            height: 30px;
        }
    }

    .zjdBox {
        width: 420px;
        height: 520px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
    }

    .Sign {
        height: 300px;
        text-align: center;
        display: flex;
        padding: 0;
        flex-direction: column;
        justify-content: space-around;
        color: #000;

        .success {
            font-size: 22px;
        }

        .continuity {
            font-size: 25px;
        }

        .el-button {
            margin-bottom: 50px;
        }

        p {
            text-align: left;
            display: flex;
            justify-content: center;
        }
    }

    .zjdGet {
        position: fixed;
        top: 20px;
        left: 20px;
        background: rgba(0, 0, 0, 0.3);
        width: 90px;
        // height: 120px;
        text-align: center;
        cursor: pointer;
        z-index: 99;
    }

    .zjdimg img {
        width: 60px;
    }

    .zjdtext {
        color: #fff;
        font-size: 12px;
        line-height: 30px;

        >b {
            font-weight: normal;
        }
    }

    .TopComStyle {
        position: relative;
        height: 60px;
        width: 100%;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: undefined, inset 0px -1px 0px 0px rgba(0, 0, 0, 0.08);

        .qiandao {
            position: fixed;
            display: flex;
            flex-direction: column;
            align-items: center;
            right: 200px;
            margin-top: 50px;
            cursor: pointer;

            // z-index: 2;
            .daka {
                font-size: 25px;
            }
        }

        .el-dropdown {
            cursor: pointer;
        }
    }

    .topContainer {
        width: 1200px;
        height: 100%;
        margin: 0px auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: white;
    }

    /* 1 */
    .topConLeft {
        display: flex;
        align-items: center;
        justify-content: space-around;
        font-size: 17px;
        cursor: pointer;
    }

    .topConLeft img {
        width: 150px;
        height: 55px;
    }

    .topConLeft span {
        cursor: pointer;
        color: #666;
        font-size: 16px;
        margin-left: 25px;
        padding: 0px 3px;
        line-height: 30px;
    }

    .topConLeft span.cur {
        // color: #fb7d0f;
        border-bottom: 3px solid #fb7d0f;
    }

    /* 2 */
    .el-input {
        /* width: 250px; */
        text-align: left;
        font-family: PingFangSC-Regular;
    }

    .topContainer>>>.el-input__inner {
        color: rgba(0, 0, 0, 0.25);
        font-size: 14px;
    }

    /* 3 */
    .TopConRight {
        color: black;
        color: rgba(102, 102, 102, 1);
        /* font-size: 14px; */
        font-size: 16px;

    }

    .TopConRight>span {
        margin-left: 15px;
    }

    .q {
        width: 100%;
        display: flex;
        justify-content: space-between;

        .r {
            margin: 0 auto;
        }

        .r div {
            width: 375px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            background-color: yellowgreen;
            border: 1px solid #000;
            font-size: 20px;
        }

        // .zjdBox {
        //     width: 500px;

        //     background-color: #fff;
        // }

        .hdcc {
            width: 150px;
            height: 30px;
            background-color: #63000f;
            border-radius: 30px;
            line-height: 30px;
            text-align: center;
            margin: 0 auto;
        }

        .prInfo {
            position: absolute;
            top: 80px;
            right: 35px;
            width: 330px;
            height: 400px;
            background-color: #fff;
            border-radius: 10px;
        }

        .prInfo-info {
            width: 150px;
            height: 30px;
            background-color: #63000f;
            border-radius: 30px;
            margin: 10px auto;
            line-height: 30px;
            text-align: center;

        }

        .notice {
            width: 270px;
            height: 300px;
            border-radius: 8px;
            // border: 1px solid #eee;

        }

        .notice__inner {
            width: 100%;
            height: 100%;
            overflow: hidden;
            font-size: 14px;
            color: #999;
        }

        .notice__box {
            animation: roll 2s linear infinite;
        }

        .notice__item {
            width: 100%;
            height: 100px;
            line-height: 100px;
            padding: 0 12px;
            overflow: hidden;
            text-align: center;
            white-space: nowrap;
        }

        @keyframes roll {
            0% {
                transform: translatey(0);
            }

            100% {
                transform: translatey(-300px);
            }
        }

        .zjdtime {
            font-size: 24px;
            position: absolute;
            top: 0;
            left: 0;
        }

        .hdcc1 {
            width: 300px;
            height: 400px;
            background-color: pink;
            position: absolute;
            top: 80px;
            left: 35px;
        }

        .hdcc1 div {
            width: 342px;
            height: 40px;
            border: 1px solid #fff;
            line-height: 40px;
            text-align: center;
        }


        /* .popbox {
            height: 42px;
            width: 42px;
            position: absolute;
            bottom: 30px;
            left: 50%;
            z-index: 999;
            margin-left: -21px;
            cursor: pointer;
        } */

        /* .lottery-alertgx {
            -moz-border-radius: 15px;
            border-radius: 15px;
        } */

        /* .lottery-alertgx,
        .lottery-tip {
            max-width: 100%;
            text-align: center;
            z-index: 10000;

            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%)
        } */

        .lottery-alerth1 {
            font-size: 20px;
            font-weight: 400;
            color: #000;
            position: relative;
            // margin-top: 20px;
        }

        .zjdContainer {
            font-family: Avenir, Helvetica, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            text-align: center;
            color: #666;
            background-color: #bd2a33;
            height: 100%;
            width: 100%;
        }

        .zjdtitle {
            position: absolute;
            top: 20px;
            width: 100%;
            text-align: center;
        }

        .myprize {
            -moz-border-radius: 20px;
            border-radius: 20px;
            padding: 8px 20px;
            color: #edd251;
            font-weight: bold;
            font-size: 18px;

            margin: auto;
            // background: #fff;
        }

        .myprizeimg {
            width: 260px;
            height: 260px;
            background-color: pink;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            left: 120px;
            bottom: 90px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .myprizetitle {
            position: absolute;
            bottom: 45px;
            left: -5%;
            width: 150px;
            height: 30px;
            border-radius: 30px;
            border: 1px solid #999;
            text-align: center;
            line-height: 30px;
            margin-left: 200px;
        }

        .linqu {
            position: absolute;
            bottom: 0;
            left: 37%;
            width: 100px;
            height: 30px;
            border-radius: 30px;
            border: 1px solid #999;
            text-align: center;
            line-height: 30px;
            margin-bottom: 1px;
            cursor: pointer;
        }

        .nostate {
            width: 500px;
            height: 100px;
            // border: 1px solid #fff;
            line-height: 100px;
            text-align: center;
            font-size: 38px;
            position: absolute;
            left: 30%;
            top: 36%;
        }

    }


    ul {
        list-style: none;
    }

    a img {
        border: none;
    }

    a {
        color: #333;
        text-decoration: none;
    }

    a:hover {
        color: #ff0000;
    }

    #mooc {
        width: 399px;
        border: 5px solid #ababab;
        border-radius: 15px;
        box-shadow: 2px 2px 10px #ababab;
        margin: 50px auto 0;
        text-align: left;
        height: 300px;
        /* 增加整体高度 */
    }

    #moocTitle {
        height: 62px;
        overflow: hidden;
        font-size: 26px;
        line-height: 62px;
        padding-left: 30px;
        background-image: linear-gradient(top, #f05e6f, #c9394a);
        border: 1px solid #f05e6f;
        border-radius: 8px 8px 0 0;
        color: #fff;
        position: relative;
    }

    #moocTitle a {
        position: absolute;
        right: 10px;
        bottom: 10px;
        display: inline;
        color: #fff;
        font-size: 12px;
        line-height: 24px;
    }

    #moocBox {
        height: 335px;
        /* 增加内容区域高度 */
        margin-top: 15px;
        overflow: hidden;
        height: 335px;
        margin-left: 10px;
        margin-right: 10px;

    }

    #mooc ul li {
        height: 40px;
        /* 增加单行高度 */
        line-height: 40px;
        /* 设置行高 */
    }

    #mooc ul li a {
        width: 180px;
        float: left;
        display: block;
        overflow: hidden;
        text-indent: 15px;
        height: 40px;
    }

    #mooc ul li span {
        float: right;
        color: #999;
    }

    .bottxtx {
        font-size: 16px;
        display: block !important;
        /* margin-left: 4%; */
        text-align: center;
        color: #63000f;
        font-weight: 700;
    }

    .leckname {
        margin: 0 2px;
        padding: 5px 10px;
        cursor: pointer;
        color: #005aa0;
    }
    .lecknames {
        padding: 5px 8px;
        cursor: pointer;
        color: #005aa0;
    }
    .lecknames:hover {
        padding: 5px 8px;
        cursor: pointer;
        // color: #e4393c;
        text-decoration: underline;

    }
    .leckname:hover {
        margin: 0 2px;
        padding: 5px 10px;
        cursor: pointer;
        // color: #e4393c;
        text-decoration: underline;

    }

    .tooltip {
        display: none;
        /* 初始状态隐藏 */
        position: absolute;
        top: 0;
        background-color: pink;
        border: 1px solid #ccc;
        padding: 10px;
        z-index: 1;
        flex: 1;
        height: 40px;
        width: 100px;
        background-color: #fff;
        font-size: 14px;
    }

    .parent {
        position: relative;
    }

    .parent:hover .tooltip {
        display: block;
        /* 鼠标悬停时显示 */
    }

    .searchcontainer {
        width: 90%;
        /* 设置搜索框容器的宽度 */
        border: 2px solid #ca1a1b;
        display: flex;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }

    .searchcontainer-input {
        border: none;
        padding: 10px;
        width: 87%;
        font-size: 14px;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        outline: none;
    }

    .header_sousuo {
        width: 1224px;
        margin: 0 auto;
        background-color: #fff;
    }

    .selectedit {
        background-color: lightblue;
    }

    .tag-container {
        // margin: 0 10px;
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        /* width: 92%; */
        /* 设置容器宽度为100% */
        align-items: center;
    }

    .el-tag {
        margin-right: 5px;
        // margin-right: 10px;
        // margin-bottom: 10px;
        /* 标签之间的间距，可以根据需要调整 */
    }
    .moreTo{
        padding-left: 10px; border: 1px solid #e3e3e3; padding: 5px; cursor: pointer;color:#666;font-size:12px;
    }
    .moreTo:hover{
        color:#ca1a1b;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/SearchComponentcopy1.vue